import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=fa9c8708&scoped=true&"
import script from "./CarList.vue?vue&type=script&lang=js&"
export * from "./CarList.vue?vue&type=script&lang=js&"
import style0 from "./CarList.vue?vue&type=style&index=0&id=fa9c8708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9c8708",
  null
  
)

component.options.__file = "CarList.vue"
export default component.exports